import { c as _c } from "react/compiler-runtime";
import { useSnackbar } from "notistack";
import { isArgumentTreeType } from "#/entities/argument/lib";
import { ArgumentType } from "#/entities/argument/model/argumentObject";
import { caseSlice } from "#/entities/argument/model/caseSlice";
import type { TreeArgumentData } from "#/entities/argument/model/types";
import { selectIsEditable } from "#/features/project/model/projectSlice";
import { api } from "#/shared/api";
import { useAppDispatch, useAppSelector, useAppStore } from "#/store/hooks";
import { type RootState } from "#/store/makeStore";
function* iterateGraphStructures(state: RootState) {
  for (const treeName in state.treeNode) {
    const treeState = state.treeNode[treeName];
    if (!treeState || treeState.type !== ArgumentType.GRAPH) continue;
    const caseArg = state.testCase.args.entities[treeName];
    if (!caseArg) {
      console.error(`Case argument ${treeName} not found`);
      continue;
    }
    if (!isArgumentTreeType(caseArg)) continue;
    yield {
      treeName,
      treeState,
      caseArg
    };
  }
}
export const useArgumentsNodeData = () => {
  const $ = _c(14);
  const store = useAppStore();
  const dispatch = useAppDispatch();
  const trpcUtils = api.useUtils();
  const {
    enqueueSnackbar
  } = useSnackbar();
  const isEditable = useAppSelector(selectIsEditable);
  let t0;
  if ($[0] !== trpcUtils) {
    t0 = {
      onSuccess: data => {
        trpcUtils.project.getCaseBySlug.setData({
          projectId: data.projectId,
          slug: data.slug
        }, data);
      }
    };
    $[0] = trpcUtils;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const updateCase = api.project.updateCase.useMutation(t0);
  let t1;
  if ($[2] !== dispatch || $[3] !== enqueueSnackbar || $[4] !== isEditable || $[5] !== store || $[6] !== updateCase) {
    t1 = async () => {
      const state = store.getState();
      for (const {
        treeName,
        treeState,
        caseArg
      } of iterateGraphStructures(state)) {
        const dataMap = {};
        for (const nodeId in treeState.nodes.entities) {
          const node = treeState.nodes.entities[nodeId];
          if (!node) {
            continue;
          }
          const {
            x,
            y
          } = node;
          if (node.value === undefined) {
            continue;
          }
          dataMap[node.value] = {
            x,
            y
          };
        }
        const projectId = state.testCase.projectId;
        const caseId = state.testCase.caseId;
        const args = state.testCase.args.entities;
        if (!projectId || !caseId || !args) {
          continue;
        }
        if (isEditable) {
          ;
          try {
            await updateCase.mutateAsync({
              projectId,
              caseId,
              args: {
                ...args,
                [treeName]: {
                  ...caseArg,
                  nodeData: dataMap
                }
              }
            });
          } catch (t2) {
            const error = t2;
            if (error instanceof Error) {
              enqueueSnackbar(error.message, {
                variant: "error"
              });
            }
            console.error("Failed to save graph node data on server", error);
          }
        }
        dispatch(caseSlice.actions.updateNodeData({
          ...caseArg,
          nodeData: dataMap
        }));
      }
    };
    $[2] = dispatch;
    $[3] = enqueueSnackbar;
    $[4] = isEditable;
    $[5] = store;
    $[6] = updateCase;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const saveGraphNodePositions = t1;
  let t2;
  if ($[8] !== dispatch || $[9] !== store) {
    t2 = async () => {
      const state_0 = store.getState();
      for (const {
        treeName: treeName_0
      } of iterateGraphStructures(state_0)) {
        const projectId_0 = state_0.testCase.projectId;
        const caseId_0 = state_0.testCase.caseId;
        const args_0 = state_0.testCase.args.entities;
        if (!projectId_0 || !caseId_0 || !args_0) {
          continue;
        }
        dispatch(caseSlice.actions.clearNodeData(treeName_0));
      }
    };
    $[8] = dispatch;
    $[9] = store;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  const clearGraphNodePositions = t2;
  let t3;
  if ($[11] !== clearGraphNodePositions || $[12] !== saveGraphNodePositions) {
    t3 = {
      saveGraphNodePositions,
      clearGraphNodePositions
    };
    $[11] = clearGraphNodePositions;
    $[12] = saveGraphNodePositions;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
};